import { HttpRequestStatus } from 'model/enums/httpRequestStatus';
import { Reducer } from 'redux';
import { NumberOfParticipantsActionTypes, NumberOfParticipantsState } from './types';

export const initialState: NumberOfParticipantsState = {
    status: HttpRequestStatus.NOOP,
    report: undefined,
    error: undefined
};

const reducer: Reducer<NumberOfParticipantsState> = (state = initialState, action): NumberOfParticipantsState => {
    switch (action.type) {
        case NumberOfParticipantsActionTypes.NUMBER_OF_PARTICIPANTS_REQUEST: {
            return { ...state, status: HttpRequestStatus.ONGOING, report: undefined, error: undefined };
        }
        case NumberOfParticipantsActionTypes.NUMBER_OF_PARTICIPANTS_SUCCESS: {
            return { ...state, status: HttpRequestStatus.SUCCESS, report: action.payload, error: undefined };
        }
        case NumberOfParticipantsActionTypes.NUMBER_OF_PARTICIPANTS_ERROR: {
            return { ...state, status: HttpRequestStatus.ERROR, error: action.payload };
        }
        case NumberOfParticipantsActionTypes.NUMBER_OF_PARTICIPANTS_RESET_STATE: {
            return { ...initialState };
        }
        default: {
            return state;
        }
    }
};

export { reducer as numberOfParticipantsReducer };
